import { useRouter } from 'next/router';

import { WithLegacy } from '~/_legacy/components/WithLegacy';

import { OnlyWeb } from '~/components/_for-next/OnlyWeb';
import { WithNextSeo } from '~/components/_for-next/WithNextSeo';

import { Template } from './_template';

export default function Page() {
  const router = useRouter();
  const id = router.query.id as string | undefined;

  return (
    <WithNextSeo title='わくわく寄付'>
      <WithLegacy>
        <OnlyWeb>{id && <Template id={id} />}</OnlyWeb>
      </WithLegacy>
    </WithNextSeo>
  );
}
